import { put, takeEvery } from 'redux-saga/effects';

export function* init() {
    yield put({ type: 'cordial:init'});
    yield put({ type: 'cordial:browse'});
}

export function* root() {
    yield takeEvery('cosmic-profile:init', init);
}
